import React, { useEffect, useRef, useState } from "react";
// import { useParams } from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";
import {
  apibaseurl,
  base_path,
  jwttoken,
} from "../../../environment";
import axios from "axios";
import Swal from "sweetalert2";
type PasswordField = "password" | "confirmPassword";

export interface RawEmployeeDetails {
  employee_id: string;
  employee_name: string;
  designation: string;
  department: string;
  sub_department: string;
  email_id: string;
  contact_number: string;
  work_location: string;
  join_date: string;
  band: string;
  cost_center_code: string;
  cost_center_name: string;
  date_of_birth: string;
  gender: string;
  primary_manager: string;
  secondary_manager: string;
  extension_number: string;
  alternate_contact_number: string;
  blood_group: string;
  photo: string;
}

export interface EmployeeDetails {
  EmpId: string;
  Name: string;
  Designation: string;
  Department: string;
  SubDepartment: string;
  Email: string;
  Contact: string;
  WorkLocation: string;
  JoinDate: string;
  Band: string;
  CostCenterCode: string;
  CostCenterName: string;
  DOB: string;
  Gender: string;
  PrimaryManager: string;
  SecondaryManager: string;
  Extension: string;
  AlternateContact: string;
  BloodGroup: string;
  Image: any;
}
interface AawardData {
  ID: Number;
  award_name: String;
}
interface AawardListMainResponse {
  success: Boolean;
  message: String;
  statusCode: Number;
  data: AawardData[];
}

const EmployeeDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState({
    emp_name: "",
    award_name: "",
    citation: "",
  });

  const getInputData = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };
  const [employeeDetails, setEmployeeDetails] =
    useState<EmployeeDetails | null>(null);

  const { data: employeeRawData, loading: employeeIdLoading } = useApi<{
    success: boolean;
    data: RawEmployeeDetails[];
  }>(`/api/get-employee-details/${id}`, {
    method: "GET",
    autoCall: !!id,
    dependencies: [id],
  });

  useEffect(() => {
    if (employeeRawData?.data?.length) {
      const emp = employeeRawData.data[0];

      const transformed: EmployeeDetails = {
        EmpId: emp.employee_id,
        Name: emp.employee_name,
        Designation: emp.designation,
        Department: emp.department,
        SubDepartment: emp.sub_department,
        Email: emp.email_id,
        Contact: emp.contact_number,
        WorkLocation: emp.work_location,
        JoinDate: emp.join_date,
        Band: emp.band,
        CostCenterCode: emp.cost_center_code,
        CostCenterName: emp.cost_center_name,
        DOB: emp.date_of_birth,
        Gender: emp.gender,
        PrimaryManager: emp.primary_manager,
        SecondaryManager: emp.secondary_manager,
        Extension: emp.extension_number,
        AlternateContact: emp.alternate_contact_number,
        BloodGroup: emp.blood_group,
        Image: emp.photo,
      };

      setEmployeeDetails(transformed);
    }
  }, [employeeRawData]);

  const chartRef = useRef(null);
  const [orgdata, setOrgdata] = useState({ data: [], node: [] });
  const [loading, setLoading] = useState(false);

  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (orgdata.node.length > 0 && wrapperRef.current) {
      setTimeout(() => {
        const el = wrapperRef.current!;
        el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
      }, 100);
    }
  }, [orgdata.node]);

  useEffect(() => {
    const fetchData = async () => {
      if (!employeeDetails?.EmpId) return;
      setLoading(true);
      try {
        const res = await axios.post(
          `${apibaseurl}/api/employee-organizational-structure`,
          { employee_id: employeeDetails?.EmpId },
          {
            headers: {
              Authorization: `Bearer ${jwttoken}`,
            },
          }
        );
        if (res.status === 200) {
          setOrgdata({
            data: res.data.data,
            node: res.data.nodes,
          });
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Failed to fetch org data:", error);
      }
    };
    fetchData();
  }, [employeeDetails]);

  useEffect(() => {
    if (window.Highcharts && orgdata.node.length > 0) {
      const baseHeight = 150;
      const heightPerNode = 30; // tweak as needed
      const dynamicHeight = baseHeight + orgdata.node.length * heightPerNode;

      window.Highcharts.chart(chartRef.current, {
        chart: {
          height: dynamicHeight,
          inverted: true,
        },
        title: {
          text: "Organization Structure",
        },
        accessibility: {
          point: {
            descriptionFormatter: function (point: any) {
              const nodeName = point.toNode.name,
                nodeId = point.toNode.id,
                nodeDesc =
                  nodeName === nodeId ? nodeName : `${nodeName}, ${nodeId}`,
                parentDesc = point.fromNode.id;
              return `${point.index}. ${nodeDesc}, reports to ${parentDesc}.`;
            },
          },
        },
        plotOptions: {
          organization: {
            collapseButton: {
              enabled: true,
              lineColor: "#666",
              fillColor: "#ccc",
              style: {
                fontSize: "10px",
                fontWeight: "bold",
              },
            },
          },
        },
        series: [
          {
            type: "organization",
            name: "Team",
            keys: ["from", "to"],
            data: orgdata.data,
            nodes: orgdata.node.map((node: any) => ({
              ...node,
              collapsed: node.collapsed ?? true,
            })),
            colorByPoint: false,
            color: "#007ad0",
            borderColor: "white",
            nodeWidth: 65,
            dataLabels: {
              useHTML: true,
              nodeFormatter: function (this: any) {
                const image = this.image
                  ? `<img src="${this.image}" style="width: 45px; height: 45px; border-radius: 50%; margin-bottom: 4px;" />`
                  : `<img src="../assets/img/logo/profilepic.jpg" style="width: 30px; height: 30px; border-radius: 50%; margin-bottom: 4px;" />`;

                const name = `<div style="font-size: 14px; font-weight: 700;">${this.name}</div>`;

                const title = this.title
                  ? `<div style="font-size: 10px; font-weight: 400;">${this.title}</div>`
                  : "<div style='font-size:8px; font-style:italic; color:gray;'></div>";

                return `
                       <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                       <div style="display: flex; flex-direction: row; align-items: center; padding: 5px;">
                       ${image}
                      <div style="display: flex; flex-direction: column; margin-left: 8px;">
                      ${name}
                      ${title}
                     </div>
                     </div>
                      </div>
                      `;
              },
            },
            levels: [
              { level: 0, color: "silver", height: 25 },
              { level: 1, color: "silver", height: 25 },
              { level: 2, color: "#F89520" },
              { level: 4, color: "#359154" },
            ],
          },
        ],

        tooltip: { outside: true },
        exporting: {
          allowHTML: true,
          sourceWidth: 800,
          sourceHeight: 600,
        },
      });
    }
  }, [orgdata]);

  const {
    data: awardListResponse,
    loading: awardListLoading,
    error: awardListError,
  } = useApi<AawardListMainResponse>("/api/awards", {
    method: "GET",
  });

  const postData = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const payload = {
      employee_id: employeeDetails?.EmpId,
      award_id: data.award_name,
      citation: data.citation,
    };

    try {
      const response = await axios.post(
        `${apibaseurl}/api/add-recognise`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${jwttoken}`,
            "Content-type": "application/json",
          },
        }
      );
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Recognition has been submitted successfully.",
      });
      setData({
        emp_name: "", // reset this too if needed
        award_name: "",
        citation: "",
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "There was a problem submitting the recognition.",
      });
    }
  };

  return (
    <>
      <Loader
        loading={employeeIdLoading || awardListLoading}

      />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h5 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
                <Link to={all_routes.employeedirectory}>
                  <i className="ti ti-arrow-left me-2" />
                  Employee Details
                </Link>
              </h5>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#add_bank_satutory"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  RECOGNISE
                </Link>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-4 theiaStickySidebar">
              <div className="card card-bg-1">
                <div className="card-body p-0">
                  <span className="avatar avatar-xl avatar-rounded border border-2 border-white m-auto d-flex mb-2">
                    <ImageWithBasePath
                      src={
                        employeeDetails?.Image ||
                        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQABqQIdskCD9BK0I81EbVfV9tTz320XvJ35A&s"
                      }
                      className="w-auto h-auto"
                      alt="Img"
                    />
                  </span>
                  <div className="text-center px-3 pb-3 border-bottom">
                    <div className="mb-3">
                      <h5 className="d-flex align-items-center justify-content-center mb-1">
                        {employeeDetails?.Name}
                        <i className="ti ti-discount-check-filled text-success ms-1" />
                      </h5>
                      <span className="badge badge-soft-dark fw-medium me-2">
                        <i className="ti ti-point-filled me-1" />
                        Corporate
                      </span>
                      <Link
                        to="#"
                        className="text-info d-inline-flex align-items-center"
                      >
                        {employeeDetails?.Email}
                      </Link>
                    </div>
                    <div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="fa-solid fa-id-card me-2" />
                          Emp ID
                        </span>
                        <p className="text-dark">{employeeDetails?.EmpId}</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="fa-solid fa-building me-2" />
                          Department
                        </span>
                        <p className="text-dark">
                          {employeeDetails?.Department}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span
                          className="d-inline-flex align-items-center"
                          style={{ textAlign: "left" }}
                        >
                          <i className="fa-solid fa-sitemap me-2" />
                          Sub Department:
                        </span>
                        <p className="text-dark" style={{ textAlign: "right" }}>
                          {employeeDetails?.SubDepartment}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="fa-solid fa-chart-line me-2" />
                          Band
                        </span>
                        <p className="text-dark">{employeeDetails?.Band}</p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="fa-solid fa-file-invoice me-2"></i>
                          Cost Center Code
                        </span>
                        <p className="text-dark">
                          {employeeDetails?.CostCenterCode}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="d-inline-flex align-items-center">
                          <i className="fa-solid fa-id-badge me-2"></i>
                          Cost Center Name
                        </span>
                        <p className="text-dark">
                          {employeeDetails?.CostCenterName}
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="d-inline-flex align-items-center">
                          <i className="fa-solid fa-location-dot me-2" />
                          Office Location
                        </span>
                        <div className="d-flex align-items-center">
                          <p className="text-gray-9 mb-0">
                            {employeeDetails?.WorkLocation}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Biographical</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="fa-solid fa-calendar-day me-2" />
                        Date of Birth
                      </span>
                      <p className="text-dark">{employeeDetails?.DOB}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="fa-solid fa-phone me-2"></i>
                        Contact Number
                      </span>
                      <Link
                        to="#"
                        className="text-info d-inline-flex align-items-center"
                      >
                        {employeeDetails?.Contact}
                      </Link>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="fa-solid fa-mars me-2"></i>
                        Gender
                      </span>
                      <p className="text-dark text-end">
                        {employeeDetails?.Gender}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Managers</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="fa-solid fa-user-tie me-2"></i>
                        Primary Manager
                      </span>
                      <p className="text-dark">
                        {employeeDetails?.PrimaryManager}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="fa-solid fa-users me-2"></i>
                        Secondary Manager
                      </span>
                      <p className="text-dark">
                        {employeeDetails?.SecondaryManager}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Contacts</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="fa-solid fa-phone-alt me-2"></i>
                        Extension Number
                      </span>
                      <p className="text-dark">{employeeDetails?.Extension}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="fa-solid fa-phone-alt me-2"></i>
                        Alternate Contact Number:
                      </span>
                      {employeeDetails?.AlternateContact}
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Emergency</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="fa-solid fa-heart me-2"></i>
                        Blood Group
                      </span>
                      <p className="text-dark">{employeeDetails?.BloodGroup}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div>
                <div className="tab-content custom-accordion-items">
                  <div
                    className="tab-pane active show"
                    id="bottom-justified-tab1"
                    role="tabpanel"
                  >
                    <div
                      className="accordion accordions-items-seperate"
                      id="accordionExample"
                    >
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingOne">
                          <div className="accordion-button">
                            <div className="d-flex align-items-center flex-fill">
                              {/* <h5>Organisational Structure</h5> */}
                            </div>
                          </div>
                        </div>
                        <div>
                          <figure
                            className="highcharts-figure"
                            ref={wrapperRef}
                            style={{
                              overflowX: "auto",
                              overflowY: "auto",
                              width: "100%",
                              position: "relative",
                            }}
                          >
                            <div
                              id="container"
                              ref={chartRef}
                              style={{
                                minWidth: Math.max(
                                  orgdata.node.length * 200,
                                  1000
                                ),
                              }}
                            ></div>
                          </figure>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      {/* Add Statuorty */}
      <div className="modal fade" id="add_bank_satutory">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Recognition Form</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={postData}>
              <div className="modal-body pb-0">
                <div className="mb-2">
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Employee <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          value={employeeDetails?.Name}
                          className="form-control"
                          readOnly
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Reward Name<span className="text-danger"> *</span>
                        </label>
                        <select
                          className="form-select select"
                          defaultValue=""
                          name="award_name"
                          onChange={getInputData}
                          value={data.award_name}
                          required
                        >
                          <option value="">Select</option>
                          {awardListResponse?.data?.map((item: any) => (
                            <option key={item.ID} value={item.ID}>
                              {item.award_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Add Citation <span className="text-danger"> *</span>
                        </label>
                        <textarea
                          className="form-control"
                          defaultValue=""
                          name="citation"
                          onChange={getInputData}
                          value={data.citation}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  // data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeDetails;
